module.exports = __webpack_public_path__ + "static/img/brendenlapierre_circle150.c924c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/brendenlapierre_circle150.png
// module id = jZHK
// module chunks = 0